module["exports"] = [
  "#{street_name} #{building_number}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/address/street_address.js
 ** module id = 327
 ** module chunks = 0
 **/